"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Styled = exports.DetailedRectangle = exports.BusRectangle = exports.LightRailVehicleRectangle = void 0;

var StyledRectangle = _interopRequireWildcard(require("./styled"));

exports.Styled = StyledRectangle;

var utils = _interopRequireWildcard(require("../../../utils"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * Gets a marker size ([width, height]) for a given zoom level.
 * Used with rectangular vehicle shapes.
 */
function getRectangleSize(zoom) {
  const veryCloseZoom = 19;
  const closeZoom = 14;
  const farZoom = 10;
  let size = zoom;
  if (zoom >= veryCloseZoom) size = zoom * 3;else if (zoom >= closeZoom) size = zoom * 2 + 3;else if (zoom > farZoom) size = zoom + 6;
  return [size, size];
}

const LightRailVehicleRectangle = utils.makeRotatedMarker(utils.makeBasicVehicleShape(StyledRectangle.LgShape, StyledRectangle.LgTrackedShape), getRectangleSize);
exports.LightRailVehicleRectangle = LightRailVehicleRectangle;
const BusRectangle = utils.makeRotatedMarker(utils.makeBasicVehicleShape(StyledRectangle.Shape, StyledRectangle.TrackedShape), getRectangleSize);
exports.BusRectangle = BusRectangle;
const DetailedRectangle = utils.makeRotatedMarker(({
  color,
  highlightColor,
  isTracked,
  routeType
}) => {
  return utils.makeVehicleIcon(StyledRectangle, routeType, color, highlightColor, isTracked);
}, getRectangleSize); // Rename styled components for export

exports.DetailedRectangle = DetailedRectangle;
//# sourceMappingURL=index.js.map